import { render, staticRenderFns } from "./PopupRiskInfoEp1.vue?vue&type=template&id=04b58d50&scoped=true&"
import script from "./PopupRiskInfoEp1.vue?vue&type=script&lang=js&"
export * from "./PopupRiskInfoEp1.vue?vue&type=script&lang=js&"
import style0 from "./PopupRiskInfoEp1.vue?vue&type=style&index=0&id=04b58d50&prod&lang=scss&scoped=true&"
import style1 from "./PopupRiskInfoEp1.vue?vue&type=style&index=1&id=04b58d50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b58d50",
  null
  
)

export default component.exports